import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { fetchLicenseRenewal } from 'dashboard/actions/license-renewal/license-renewal.actions';
import { isRetailerDashboardSelector, isChainHeadSelector } from 'selectors';
import template from './license-renewal-widget.html';

const mapStateToThis = (state) => {
  const { session, config, licenseRenewal } = state;
  const { retailerDashboard, retailer } = session;
  const { licenseRenewalContactUrl, licenseRenewalEnabled } = config;
  const { retailers, isLoading } = licenseRenewal;

  const isChainHead = isChainHeadSelector(state);
  const isPreviewingRetailerDashboards = isRetailerDashboardSelector(state);

  return {
    retailer,
    retailerDashboard,
    licenseRenewalContactUrl,
    retailers,
    isLoading,
    isChainHead,
    licenseRenewalEnabled,
    isPreviewingRetailerDashboards,
    isEmpty: retailers.length === 0,
  };
};

const mapDispatchToThis = {
  fetchLicenseRenewal,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class LicenceRenewalWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    if (this.licenseRenewalEnabled) {
      this.$scope.$applyAsync(this.fetchLicenseRenewal(retailerId));
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class LicenceRenewalWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.template = template;
    this.controller = LicenceRenewalWidgetController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/license-renewal/license-renewal-widget-component.js